
import { AuditEscalationGroupModel, AuditFaultTypeModel, EscalationGroupTypeEnum, QueryOperator } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, Ref, VModel, Vue } from 'vue-property-decorator';
import Autocomplete from '../components/Autocomplete.vue';
import { auditFaultTypesStore } from '@/libs/audit-fault-types/+state/store';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { auditEscalationGroupsStore } from '@/libs/audit-escalation-groups/+state/store';

@Component({})
export default class WorkplaceSelect extends Vue {
    @VModel() innerValue!: string;
    @Prop({ default: '' }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: true }) serverSide!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: null }) auditId!: string | string[] | null;
    @Prop({ default: null }) escalationType!: EscalationGroupTypeEnum | EscalationGroupTypeEnum[] | null;
    @Prop() placeholder!: string;
    @Prop() attach!: string;

    @Ref() autocomplete!: Autocomplete;

    get items(): AuditEscalationGroupModel[] {
        let items = [
            ...(auditEscalationGroupsStore.useGetter(
                CrudGetter.Data,
                'EscalationGroupSelect'
            ) as AuditEscalationGroupModel[]),
        ];
        if (this.escalationType) {
            if (Array.isArray(this.escalationType)) {
                items = items.filter((x) => this.escalationType?.contains(x.escalationGroupType!) == true);
            } else if (this.escalationType.length > 0) {
                items = items.filter((x) => x.escalationGroupType === this.escalationType);
            }
        }
        if (this.auditId) {
            if (Array.isArray(this.auditId)) {
                items = items.filter((x) => this.auditId?.contains(x.auditId!) == true);
            } else if (this.auditId.length > 0) {
                items = items.filter((x) => x.auditId === this.auditId);
            }
        }
        return items.sort((a: AuditEscalationGroupModel, b: AuditEscalationGroupModel) => {
            if ((a.group?.name ?? '') < (b.group?.name ?? '')) {
                return -1;
            }
            if ((a.group?.name ?? '') > (b.group?.name ?? '')) {
                return 1;
            }
            return 0;
        });
    }

    mounted() {
        if (this.serverSide) {
            auditEscalationGroupsStore.dispatch(
                CrudAction.GetAll,
                createCrudQueryPayload(
                    undefined,
                    [
                        {
                            field: 'auditId',
                            op: QueryOperator.In,
                            comparand: Array.isArray(this.auditId) ? this.auditId : [this.auditId],
                        },
                    ],
                    undefined,
                    false,
                    'EscalationGroupSelect'
                )
            );
        }
    }

    getName(e: AuditEscalationGroupModel) {
        return e.group?.name ?? '';
    }
}
